"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _bus_config = require("@/api/cfg/bus_config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'bus_config',
  components: {},
  data: function data() {
    return {
      oss_type: _bus_config.obj_storage_type,
      sso_type: _bus_config.sso_type,
      listQuery: {
        page: 1,
        limit: 20,
        keywords: null
      },
      comboboxList: [],
      records: [],
      total: 0,
      listLoading: false,
      dialogVisible: false,
      busCfgForm: {
        id: null,
        //主键
        cfgGroup: null,
        //配置分组
        cfgKey: null,
        //配置编码
        cfgValue: null,
        //配置值
        remarks: null //备注
      },
      cfgKeyDisplayName: null,
      //配置编码对应的显示名称
      rules: {
        cfgGroup: [{
          required: true,
          message: '请选择配置分组',
          trigger: 'blur'
        }],
        corpId: [{
          required: true,
          message: '请选择配置编码',
          trigger: 'blur'
        }],
        corpName: [{
          required: true,
          message: '请输入配置值',
          trigger: 'blur'
        }]
      }
    };
  },
  filters: {
    cfgGroupDisplay: function cfgGroupDisplay(value) {
      if (_bus_config.cfg_cons.hasOwnProperty(value)) {
        return _bus_config.cfg_cons[value];
      } else {
        return value;
      }
    },
    cfgKeyDisplayName: function cfgKeyDisplayName(value) {
      if (value === "oss") {
        return "阿里云";
      } else if (value === "sso") {
        return "单点登录";
      }
      return value;
    },
    cfgValueDisplayName: function cfgValueDisplayName(value) {
      var item = _bus_config.obj_storage_type.find(function (i) {
        return i.code === value;
      });
      if (item) {
        return item.desc;
      }
      item = _bus_config.sso_type.find(function (i) {
        return i.code === value;
      });
      if (item) {
        return item.desc;
      }
      return value;
    }
  },
  created: function created() {
    this.getConfigCombobox();
    this.getPage();
  },
  methods: {
    getConfigCombobox: function getConfigCombobox() {
      var _this = this;
      (0, _bus_config.busCfgCombobox)().then(function (res) {
        var data = res.data;
        if (data) {
          _this.comboboxList = data.records;
        }
      });
    },
    search: function search() {
      this.listQuery.page = 1;
      this.getPage();
    },
    getPage: function getPage() {
      var _this2 = this;
      (0, _bus_config.busCfgPage)(this.listQuery).then(function (res) {
        _this2.records = res.records;
      });
    },
    handleCreateCfg: function handleCreateCfg() {
      this.dialogVisible = true;
      this.initFormData();
    },
    initFormData: function initFormData() {
      this.busCfgForm = {
        id: null,
        cfgGroup: null,
        //来源渠道
        cfgKey: null,
        //企业ID
        cfgValue: null,
        //企业名称
        remarks: null //备注
      };
    },
    changeCfgGroup: function changeCfgGroup() {
      if (this.busCfgForm.cfgGroup === 'cus_cfg') {
        this.busCfgForm.cfgValue = null;
        this.busCfgForm.cfgKey = null;
        this.cfgKeyDisplayName = null;
      } else if (this.busCfgForm.cfgGroup === 'oss_cfg') {
        this.busCfgForm.cfgKey = "oss";
        this.cfgKeyDisplayName = "对象存储";
        this.busCfgForm.cfgValue = null;
      } else if (this.busCfgForm.cfgGroup === 'sso_cfg') {
        this.busCfgForm.cfgKey = "sso";
        this.cfgKeyDisplayName = "单点登录";
        this.busCfgForm.cfgValue = null;
      }
    },
    handleEditCfg: function handleEditCfg(cfg) {
      this.dialogVisible = true;
      this.busCfgForm.id = cfg.id;
      this.busCfgForm.cfgGroup = cfg.cfgGroup;
      this.busCfgForm.cfgKey = cfg.cfgKey;
      this.busCfgForm.cfgValue = cfg.cfgValue;
      this.busCfgForm.remarks = cfg.remarks;
    },
    saveOrUpdate: function saveOrUpdate() {
      var _this3 = this;
      this.$refs['busCfgForm'].validate(function (valid) {
        if (valid) {
          if (_this3.busCfgForm.id) {
            _this3.update();
          } else {
            _this3.save();
          }
        }
      });
    },
    save: function save() {
      var _this4 = this;
      (0, _bus_config.saveCfg)(this.busCfgForm).then(function () {
        _this4.dialogVisible = false;
        _this4.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 3000
        });
        //重新加载
        _this4.getPage();
      });
    },
    update: function update() {
      var _this5 = this;
      (0, _bus_config.updateCfg)(this.busCfgForm).then(function () {
        _this5.dialogVisible = false;
        _this5.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 3000
        });
        //重新加载
        _this5.getPage();
      });
    }
  }
};